import { getBusinessCount } from "../../../database/helpers/business";
import { LanguageContext } from "../../../context/LanguageContext";
import { useCallback, useContext, useEffect, useState } from "react";
import { handleDeleteBusiness } from "../DeleteBusiness";
import { ParagraphText } from "../../../Libraries";
import {
  Button,
  CircularProgress,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import ConfirmationModal from "../Modals/ConfirmationModal";
import ListItem from "./ListItem";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { isDemoMode } from "../../../utils/demoEnviornment";
import { HeaderDownIcon } from "../../../assets/icons/icon";
import { useAuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useWalletContext } from "../../../context/WalletContext";
import styles from "./styles.module.css";

const BusinessDropDown = ({
  setLoadBusiness,
  toggleBusiness,
  allBusinesses,
  business,
  navigate,
  user,
}) => {
  const [I18n] = useContext(LanguageContext);
  const { handleLogoutInDB } = useAuthContext();
  const navigateRouter = useNavigate();

  const [rBusiness, setRBusiness] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [isLogout, setLogout] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [isLogoutLoading, setIsLogoutLoading] = useState(false);
  const [backupNow, setIsBackup] = useState(false);
  const [backupToggle, setBackupToggle] = useState(false);
  const { setWalletData } = useWalletContext();

  const getAvatarSnapshot = useCallback(() => {
    const imageUrl = business?.image_url || null;
    const letter =
      imageUrl || !business?.name
        ? ""
        : business.name.trim().charAt(0).toUpperCase() || "";
    return { imageUrl, letter };
  }, [business?.image_url, business?.name]);

  const [avatarCurr, setAvatarCurr] = useState(getAvatarSnapshot);
  const [avatarPrev, setAvatarPrev] = useState(null);

  useEffect(() => {
    const next = getAvatarSnapshot();
    setAvatarCurr((curr) => {
      if (next.imageUrl === curr.imageUrl && next.letter === curr.letter) {
        return curr;
      }
      setAvatarPrev(curr);
      return next;
    });
  }, [business?.id, getAvatarSnapshot]);

  useEffect(() => {
    if (!avatarPrev) return undefined;
    const t = setTimeout(() => setAvatarPrev(null), 420);
    return () => clearTimeout(t);
  }, [avatarPrev]);



  const deleteBusiness = useCallback(async (value) => {
    await getBusinessCount().then((count) => {
      if (count === 1) {
        setOpen(true);
        triggerLogEvent(analytics, "setting_business_delete", { value });
      } else {
        setRBusiness(value);
        setOpen(true);
      }
    });
  });

  const handleDelete = useCallback(() => {
    setOpen(false);
    handleDeleteBusiness(
      "setProfileUpdted",
      setLoadBusiness,
      false,
      setLoading,
      rBusiness,
      navigate,
      user,
      I18n,
    );
  });

  const handleAction = (key, value) => {
    if (key == "switch") toggleBusiness(value);
    else deleteBusiness(value);
  };

  const handleDemoSignup = () => {
    window.open("https://web.udhaar.pk/", "_blank");
  };

  return (
    <div
      className={`businessDropdown businessDropDownHeight ${styles.root} ${menuAnchor ? "show" : ""}`}
    >
      <Button
        id="dropdown-menu-align-right"
        fullWidth
        onClick={(e) => setMenuAnchor(e.currentTarget)}
        sx={{
          textTransform: "none",
          display: "block",
          textAlign: "left",
          padding: 0,
          minWidth: 0,
        }}
      >
        {user ? (
          business?.name ? (
            <ParagraphText className={styles.businessnameBoxWrapper}>
              <span className={styles.triggerAvatarStage} aria-hidden>
                {avatarPrev ? (
                  <span
                    className={`${styles.triggerAvatarLayer} ${styles.triggerAvatarExiting}`}
                  >
                    {avatarPrev.imageUrl ? (
                      <img
                        src={avatarPrev.imageUrl}
                        alt=""
                        className={styles.triggerAvatarImg}
                        draggable={false}
                      />
                    ) : (
                      <span className={styles.triggerAvatarPlaceholder}>
                        {avatarPrev.letter}
                      </span>
                    )}
                  </span>
                ) : null}
                <span
                  className={`${styles.triggerAvatarLayer} ${
                    avatarPrev ? styles.triggerAvatarEntering : ""
                  }`}
                >
                  {avatarCurr.imageUrl ? (
                    <img
                      src={avatarCurr.imageUrl}
                      alt={business.name || ""}
                      className={styles.triggerAvatarImg}
                      draggable={false}
                    />
                  ) : (
                    <span className={styles.triggerAvatarPlaceholder}>
                      {avatarCurr.letter}
                    </span>
                  )}
                </span>
              </span>
              <span
                className={`businessNameBox ${styles.businessNameBoxTrigger}`}
              >
                {business?.name}
              </span>
              <span className={styles.businessDropdownChevron}>
                <HeaderDownIcon />
              </span>
            </ParagraphText>
          ) : (
            <ParagraphText className={styles.businessnameBoxWrapper}>
              <span className="businessNameBox">{user.phone_number}</span>
              <span className="businessCategoryBox">
                {business?.category || ""}
              </span>
              <span className={styles.businessDropdownChevron}>
                <HeaderDownIcon />
              </span>
            </ParagraphText>
          )
        ) : null}
      </Button>
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            className: styles.menuPaper,
          },
        }}
        MenuListProps={{
          component: "div",
          className: styles.menuShell,
          disablePadding: true,
        }}
      >
        <div className={styles.menuTopSection}>
          <MenuItem disabled className={styles.businessesHeaderRow}>
            <ListItemText className="businessesHeader" primary="Businesses" />
          </MenuItem>
        </div>
        <div className={styles.menuBusinessListScroll}>
          {loading ? (
            <MenuItem disabled>
              <CircularProgress size={24} className="loaderCircle" />
            </MenuItem>
          ) : (
            allBusinesses.map((item, index) => (
              <ListItem
                key={item?.id ?? index}
                handleAction={(v, x) => {
                  handleAction(v, x);
                  setMenuAnchor(null);
                }}
                business={business}
                index={index}
                I18n={I18n}
                item={item}
                user={user}
              />
            ))
          )}
        </div>
        <div className={styles.menuFooterSection}>
          <MenuItem
            className={styles.createItem}
            onClick={() => {
              setMenuAnchor(null);
              isDemoMode()
                ? handleDemoSignup()
                : navigateRouter("/CreateBusinessForm");
            }}
          >
            {isDemoMode() ? (
              <button
                id="business_dropdown_toggle_btn"
                type="button"
                className={`dropDownCreateButton ${styles.dropDownCreateButton}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDemoSignup();
                  setMenuAnchor(null);
                }}
              >
                <span>
                  <svg
                    fill="#fff"
                    height="22"
                    viewBox="0 0 60 60"
                    width="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill=""
                      d="M42.623,24.197l-15.834-0.001L26.785,8.365c0-0.319-0.141-0.646-0.389-0.894 c-0.479-0.478-1.348-0.477-1.812-0.015c-0.243,0.243-0.378,0.565-0.378,0.908v15.828H8.383c-0.709,0.002-1.287,0.58-1.285,1.288 c0,0.688,0.6,1.292,1.285,1.292l15.828,0.002L24.213,42.6c-0.002,0.32,0.14,0.646,0.387,0.896c0.25,0.251,0.578,0.396,0.9,0.396 h0.002c0.707,0,1.283-0.58,1.285-1.291l-0.002-15.824h15.83c0.344,0,0.666-0.135,0.908-0.377c0.244-0.244,0.379-0.567,0.379-0.914 C43.9,24.822,43.279,24.197,42.623,24.197z"
                    />
                  </svg>
                </span>
                <span>{" Signup & add New Business"}</span>
              </button>
            ) : (
              <span
                className={`dropDownCreateButton ${styles.createNewBusinessLabel}`}
              >
                {I18n.create_new_business}
              </span>
            )}
          </MenuItem>
        </div>
      </Menu>

      <ConfirmationModal
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={rBusiness ? handleDelete : () => setOpen(false)}
        message={
          rBusiness
            ? I18n.are_you_sure_you_want_to_delete_business
            : "You must have atleast 1 business"
        }
        title={rBusiness ? I18n.this_action_cannot_be_undone : ""}
        confirmText={rBusiness ? I18n.delete : I18n.close}
        cancelText={rBusiness ? undefined : I18n.cancel}
        loading={rBusiness ? loading : false}
        id="business_dropdown_delete_modal"
      />
    </div>
  );
};

export default BusinessDropDown;
